import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TGeneralAttachmentsApi } from './types';

export const generalAttachments: TGeneralAttachmentsApi = {
	getList: payload =>
		http
			.get(endpoint.generalAttachments.LIST, {
				params: {
					pageSize: payload.pageSize,
					pageNumber: payload.pageNumber,
				},
			})
			.then(response => response.data),
	create: payload =>
		http.post(endpoint.generalAttachments.CREATE, payload.formData).then(response => response.data),
	getOne: payload =>
		http
			.get(endpoint.generalAttachments.GET_ONE(payload.attachmentId), {
				responseType: 'blob',
			})
			.then(response => response.data),
	update: payload =>
		http
			.put(endpoint.generalAttachments.UPDATE(payload.attachmentId), payload.formData)
			.then(response => response.data),
	delete: attachmentId =>
		http.delete(endpoint.generalAttachments.DELETE(attachmentId)).then(response => response.data),
	addVersion: payload =>
		http
			.post(endpoint.generalAttachments.ADD_VERSION(payload.attachmentId), payload.formData)
			.then(response => response.data),
};
